// ============================================================
//  DONNÉES DE DÉMONSTRATION (mock) — à utiliser tant que l'API
//  RPlumber de Clément n'est pas prête. Le format renvoyé ici est
//  volontairement identique à celui attendu de la vraie API (voir
//  le contrat dans le README) pour ne rien avoir à changer dans les
//  composants le jour où on bascule sur les vraies routes.
// ============================================================

// value = clé unique pour le <Select> (idProdu seul peut être partagé par
// plusieurs variétés, ex: 118 pour les deux maïs) — idProdu/semis restent
// des champs à part, utilisés pour construire les paramètres envoyés à l'API.
const CULTURES = [
  { value: "118-04.15", idProdu: 118, semis: "04.15", label: "Maïs précoce (semis 15 avril)" },
  { value: "118-05.05", idProdu: 118, semis: "05.05", label: "Maïs tardif (semis 5 mai)" },
];

const LIBELLES = [
  { value: 31001, label: "Agenais" },
  { value: 31002, label: "Albigeois" },
  { value: 31003, label: "Lauragais" },
  { value: 31004, label: "Toulousain" },
  { value: 31005, label: "Comminges" },
  { value: 31006, label: "Quercy Blanc" },
  { value: 31007, label: "Vallée de la Garonne" },
  { value: 31008, label: "Piémont Pyrénéen" },
];

const YEARS = [2020, 2035, 2050];
const RECHAUFFEMENT = ["reference", "+2", "+2.7"];

function addDays(dateStr, n) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

function seedFrom(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

function rand(seed) {
  // petit générateur pseudo-aléatoire déterministe (évite que les graphes
  // sautent dans tous les sens à chaque re-render)
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

// "04.15" -> "2025-04-15"
function semisToDate(semis) {
  return `2025-${(semis || "04.15").replace(".", "-")}`;
}

export const mock = {
  getConfig() {
    return Promise.resolve({ cultures: CULTURES, libelles: LIBELLES });
  },

/*   
██████╗░██╗░░██╗███████╗███╗░░██╗░█████╗░
██╔══██╗██║░░██║██╔════╝████╗░██║██╔══██╗
██████╔╝███████║█████╗░░██╔██╗██║██║░░██║
██╔═══╝░██╔══██║██╔══╝░░██║╚████║██║░░██║
██║░░░░░██║░░██║███████╗██║░╚███║╚█████╔╝
╚═╝░░░░░╚═╝░░╚═╝╚══════╝╚═╝░░╚══╝░╚════╝░ */

   getPheno({ idProdu, gridno }) {
    const seed = seedFrom(String(idProdu || "") + String(gridno || "") + "pheno");

    // 11 stades = 10 étapes (transitions), calqués sur la phénologie maïs réelle.
    const stades = [
      { BBCH: 0, Libelle_SP: "Semis" },
      { BBCH: 9, Libelle_SP: "Levée" },
      { BBCH: 14, Libelle_SP: "4feuilles" },
      { BBCH: 18, Libelle_SP: "8feuilles" },
      { BBCH: 19, Libelle_SP: "9 ou plus feuilles" },
      { BBCH: 65, Libelle_SP: "Floraison femelle" },
      { BBCH: 69, Libelle_SP: "Limite avortement" },
      { BBCH: 75, Libelle_SP: "50% d'humidité - debut grain pateux" },
      { BBCH: 83, Libelle_SP: "45% d'humidité - grain pateux" },
      { BBCH: 87, Libelle_SP: "38% d'humidité - maturite complete" },
      { BBCH: 89, Libelle_SP: "32% d'humidité" },
    ];

    // Durées (en jours) entre stades consécutifs, par horizon — reprend les
    // valeurs observées sur le graphique de référence. Les stades arrivent
    // un peu plus tôt et un peu plus vite avec le réchauffement (2050 < 2020).
    const DUREES_PAR_HORIZON = {
      2020: [5, 26, 18, 15, 22, 16, 21, 2, 8, 1],
      2035: [5, 25, 17, 14, 22, 15, 21, 2, 7, 1],
      2050: [4, 23, 17, 13, 21, 14, 20, 2, 7, 1],
    };

    // Date de semis par horizon (léger décalage climatique + variation
    // seedée selon la région/culture pour ne pas avoir des courbes identiques
    // partout).
    const SEMIS_PAR_HORIZON = {
      2020: "2023-04-15",
      2035: "2023-04-15",
      2050: "2023-04-15",
    };
  
    const BCCH_RECO = [18, 65, 89];
 


    const rows = [];
    YEARS.forEach((YearGroup) => {
      const jitter = Math.round((rand(seed + YearGroup) - 0.5) * 4); // ±2 j
      const semisJour = addDays(SEMIS_PAR_HORIZON[YearGroup], jitter);
      const durees = DUREES_PAR_HORIZON[YearGroup];
 
      let offset = 0;
      let gdd = 30;
      stades.forEach((s, i) => {
        if (i > 0) {
          const dureeJitter = Math.max(1, durees[i - 1] + Math.round((rand(seed + i * 7 + YearGroup) - 0.5) * 2));
          offset += dureeJitter;
          gdd += dureeJitter * (14 + rand(seed + i) * 6); // ~14-20 GDD/jour
        }
        rows.push({
          YearGroup,
          BBCH: s.BBCH,
          JourJulien: offset,
          date_calendaire: addDays(semisJour, offset),
          GDD_VF: Math.round(gdd),
          Libelle_SP: s.Libelle_SP,
          is_reco: BCCH_RECO.includes(s.BBCH),
        });
      });
    });
    return Promise.resolve(rows);
  },

/* 
██████╗░██╗░░██╗███████╗███╗░░██╗░█████╗░  ████████╗██████╗░░█████╗░░█████╗░░█████╗░
██╔══██╗██║░░██║██╔════╝████╗░██║██╔══██╗  ╚══██╔══╝██╔══██╗██╔══██╗██╔══██╗██╔══██╗
██████╔╝███████║█████╗░░██╔██╗██║██║░░██║  ░░░██║░░░██████╔╝███████║██║░░╚═╝██║░░╚═╝
██╔═══╝░██╔══██║██╔══╝░░██║╚████║██║░░██║  ░░░██║░░░██╔══██╗██╔══██║██║░░██╗██║░░██╗
██║░░░░░██║░░██║███████╗██║░╚███║╚█████╔╝  ░░░██║░░░██║░░██║██║░░██║╚█████╔╝╚█████╔╝
╚═╝░░░░░╚═╝░░╚═╝╚══════╝╚═╝░░╚══╝░╚════╝░  ░░░╚═╝░░░╚═╝░░╚═╝╚═╝░░╚═╝░╚════╝░░╚════╝░ */

  getPhenoTRACC({ idProdu, gridno }) {
    const seed = seedFrom(String(idProdu || "") + String(gridno || "") + "pheno");

    // 11 stades = 10 étapes (transitions), calqués sur la phénologie maïs réelle.
    const stades = [
      { BBCH: 0, Libelle_SP: "Semis" },
      { BBCH: 9, Libelle_SP: "Levée" },
      { BBCH: 14, Libelle_SP: "4feuilles" },
      { BBCH: 18, Libelle_SP: "8feuilles" },
      { BBCH: 19, Libelle_SP: "9 ou plus feuilles" },
      { BBCH: 65, Libelle_SP: "Floraison femelle" },
      { BBCH: 69, Libelle_SP: "Limite avortement" },
      { BBCH: 75, Libelle_SP: "50% d'humidité - debut grain pateux" },
      { BBCH: 83, Libelle_SP: "45% d'humidité - grain pateux" },
      { BBCH: 87, Libelle_SP: "38% d'humidité - maturite complete" },
      { BBCH: 89, Libelle_SP: "32% d'humidité" },
    ];

    // Durées (en jours) entre stades consécutifs, par horizon — reprend les
    // valeurs observées sur le graphique de référence. Les stades arrivent
    // un peu plus tôt et un peu plus vite avec le réchauffement (2050 < 2020).
    const DUREES_PAR_HORIZON = {
      "reference": [5, 26, 18, 15, 22, 16, 21, 2, 8, 1],
      "+2": [5, 25, 17, 14, 22, 15, 21, 2, 7, 1],
      "+2.7": [4, 23, 17, 13, 21, 14, 20, 2, 7, 1],
    };

    // Date de semis par horizon (léger décalage climatique + variation
    // seedée selon la région/culture pour ne pas avoir des courbes identiques
    // partout).
    const SEMIS_PAR_HORIZON = {
      "reference": "2023-04-15",
      "+2": "2023-04-15",
      "+2.7": "2023-04-15",
    };
  
    const BCCH_RECO = [18, 65, 89];
 


    const rows = [];
    RECHAUFFEMENT.forEach((YearGroup, idx) => {
      const jitter = Math.round((rand(seed + idx) - 0.5) * 4); // ±2 j
      const semisJour = addDays(SEMIS_PAR_HORIZON[YearGroup], jitter);
      const durees = DUREES_PAR_HORIZON[YearGroup];

      let offset = 0;
      let gdd = 30;
      stades.forEach((s, i) => {
        if (i > 0) {
          const dureeJitter = Math.max(1, durees[i - 1] + Math.round((rand(seed + i * 7 + idx) - 0.5) * 2));
          offset += dureeJitter;
          gdd += dureeJitter * (14 + rand(seed + i) * 6); // ~14-20 GDD/jour
        }
        rows.push({
          YearGroup,
          BBCH: s.BBCH,
          JourJulien: offset,
          date_calendaire: addDays(semisJour, offset),
          GDD_VF: Math.round(gdd),
          Libelle_SP: s.Libelle_SP,
          is_reco: BCCH_RECO.includes(s.BBCH),
        });
      });
    });
    return Promise.resolve(rows);
  },


/* 
  
░█████╗░██╗░░░░░███████╗░█████╗░░██████╗
██╔══██╗██║░░░░░██╔════╝██╔══██╗██╔════╝
███████║██║░░░░░█████╗░░███████║╚█████╗░
██╔══██║██║░░░░░██╔══╝░░██╔══██║░╚═══██╗
██║░░██║███████╗███████╗██║░░██║██████╔╝
╚═╝░░╚═╝╚══════╝╚══════╝╚═╝░░╚═╝╚═════╝░ */

 getAleas({ idProdu, gridno }) {
    const codes = ["Gel", "CDC", "EE", "SHRU", "CDF"];
    const rows = [];
    codes.forEach((alea, ai) => {
      const seed = seedFrom(String(idProdu || "") + String(gridno || "") + alea);
      YEARS.forEach((YearGroup, yi) => {
        const moy = 4 + yi * 5 + rand(seed + yi + ai * 17) * 3;
        rows.push({ YearGroup, alea, stat: "Min", val: Number((moy * 0.5).toFixed(1)) });
        rows.push({ YearGroup, alea, stat: "Moy", val: Number(moy.toFixed(1)) });
        rows.push({ YearGroup, alea, stat: "Max", val: Number((moy * 1.7).toFixed(1)) });
      });
    });
    return Promise.resolve(rows);
  },

/* 

░█████╗░██╗░░░░░███████╗░█████╗░░██████╗  ████████╗██████╗░░█████╗░░█████╗░░█████╗░
██╔══██╗██║░░░░░██╔════╝██╔══██╗██╔════╝  ╚══██╔══╝██╔══██╗██╔══██╗██╔══██╗██╔══██╗
███████║██║░░░░░█████╗░░███████║╚█████╗░  ░░░██║░░░██████╔╝███████║██║░░╚═╝██║░░╚═╝
██╔══██║██║░░░░░██╔══╝░░██╔══██║░╚═══██╗  ░░░██║░░░██╔══██╗██╔══██║██║░░██╗██║░░██╗
██║░░██║███████╗███████╗██║░░██║██████╔╝  ░░░██║░░░██║░░██║██║░░██║╚█████╔╝╚█████╔╝
╚═╝░░╚═╝╚══════╝╚══════╝╚═╝░░╚═╝╚═════╝░  ░░░╚═╝░░░╚═╝░░╚═╝╚═╝░░╚═╝░╚════╝░░╚════╝░ */
  getAleasTRACC({ idProdu, gridno }) {
    const codes = ["Gel", "CDC", "EE", "SHRU", "CDF"];
    const rows = [];
    codes.forEach((alea, ai) => {
      const seed = seedFrom(String(idProdu || "") + String(gridno || "") + alea);
      RECHAUFFEMENT.forEach((YearGroup, yi) => {
        const moy = 4 + yi * 5 + rand(seed + yi + ai * 17) * 3;
        rows.push({ YearGroup, alea, stat: "Min", val: Number((moy * 0.5).toFixed(1)) });
        rows.push({ YearGroup, alea, stat: "Moy", val: Number(moy.toFixed(1)) });
        rows.push({ YearGroup, alea, stat: "Max", val: Number((moy * 1.7).toFixed(1)) });
      });
    });
    return Promise.resolve(rows);
  },


/* 
██╗███╗░░░███╗██████╗░░█████╗░░█████╗░████████╗
██║████╗░████║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝
██║██╔████╔██║██████╔╝███████║██║░░╚═╝░░░██║░░░
██║██║╚██╔╝██║██╔═══╝░██╔══██║██║░░██╗░░░██║░░░
██║██║░╚═╝░██║██║░░░░░██║░░██║╚█████╔╝░░░██║░░░
╚═╝╚═╝░░░░░╚═╝╚═╝░░░░░╚═╝░░╚═╝░╚════╝░░░░╚═╝░░░ */


   getPertes({ idProdu, gridno, risque }) {
    const seed = seedFrom(String(idProdu || "") + String(gridno || "") + (risque || ""));

    const total = YEARS.map((YearGroup, yi) => ({
      YearGroup,
      val: Number((3 + yi * 6 + rand(seed + yi) * 4).toFixed(1)),
    }));

    const codes = ["Gel", "CDC", "EE", "SHRU", "CDF"];
    const repartition = [];
    YEARS.forEach((YearGroup, yi) => {
      codes.forEach((alea, ai) => {
        repartition.push({
          YearGroup,
          alea,
          val: Number((1 + rand(seed + yi * 10 + ai) * 5).toFixed(1)),
        });
      });
    });

    return Promise.resolve({ total, repartition });
  },

/* 

██╗███╗░░░███╗██████╗░░█████╗░░█████╗░████████╗  ████████╗██████╗░░█████╗░░█████╗░░█████╗░
██║████╗░████║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝  ╚══██╔══╝██╔══██╗██╔══██╗██╔══██╗██╔══██╗
██║██╔████╔██║██████╔╝███████║██║░░╚═╝░░░██║░░░  ░░░██║░░░██████╔╝███████║██║░░╚═╝██║░░╚═╝
██║██║╚██╔╝██║██╔═══╝░██╔══██║██║░░██╗░░░██║░░░  ░░░██║░░░██╔══██╗██╔══██║██║░░██╗██║░░██╗
██║██║░╚═╝░██║██║░░░░░██║░░██║╚█████╔╝░░░██║░░░  ░░░██║░░░██║░░██║██║░░██║╚█████╔╝╚█████╔╝
╚═╝╚═╝░░░░░╚═╝╚═╝░░░░░╚═╝░░╚═╝░╚════╝░░░░╚═╝░░░  ░░░╚═╝░░░╚═╝░░╚═╝╚═╝░░╚═╝░╚════╝░░╚════╝░ */

getPertesTRACC({ idProdu, gridno, risque }) {
    const seed = seedFrom(String(idProdu || "") + String(gridno || "") + (risque || ""));

    const total = RECHAUFFEMENT.map((YearGroup, yi) => ({
      YearGroup,
      val: Number((3 + yi * 6 + rand(seed + yi) * 4).toFixed(1)),
    }));

    const codes = ["Gel", "CDC", "EE", "SHRU", "CDF"];
    const repartition = [];
    RECHAUFFEMENT.forEach((YearGroup, yi) => {
      codes.forEach((alea, ai) => {
        repartition.push({
          YearGroup,
          alea,
          val: Number((1 + rand(seed + yi * 10 + ai) * 5).toFixed(1)),
        });
      });
    });

    return Promise.resolve({ total, repartition });
  },

/* 

███████╗░█████╗░██╗░░░██╗
██╔════╝██╔══██╗██║░░░██║
█████╗░░███████║██║░░░██║
██╔══╝░░██╔══██║██║░░░██║
███████╗██║░░██║╚██████╔╝
╚══════╝╚═╝░░╚═╝░╚═════╝░ */



  getEauIrrigation({ idProdu, semis, gridno }) {
    const semisDate = semisToDate(semis);
    const seedEau = seedFrom(String(idProdu || "") + String(gridno || ""));
    const seedIrr = seedFrom(String(idProdu || "") + String(gridno || "") + "irr");
    const eau = [];
    const irrigation = [];
    YEARS.forEach((Years, yi) => {
      for (let j = 1; j <= 180; j += 2) {
        const dateAffichage = addDays(semisDate, j);

        const climatFactorEau = 1 + yi * 0.18;
        const baseEau = 2.5 + 2 * Math.sin((j / 180) * Math.PI);
        const bruitEau = (rand(seedEau + j * 7 + yi * 1000) - 0.5) * 0.6;
        eau.push({
          Years,
          jour_campagne: j,
          date_affichage: dateAffichage,
          besoin_moy: Number(Math.max(0, baseEau * climatFactorEau + bruitEau).toFixed(2)),
          besoin_sd: Number((0.4 + rand(seedEau + j) * 0.4).toFixed(2)),
        });

        const climatFactorIrr = 1 + yi * 0.22;
        const baseIrr = 1.2 + 1.5 * Math.sin((j / 180) * Math.PI);
        const bruitIrr = (rand(seedIrr + j * 5 + yi * 900) - 0.5) * 0.4;
        irrigation.push({
          Years,
          jour_campagne: j,
          date_affichage: dateAffichage,
          irr_moy: Number(Math.max(0, baseIrr * climatFactorIrr + bruitIrr).toFixed(2)),
          irr_sd: Number((0.2 + rand(seedIrr + j) * 0.2).toFixed(2)),
        });
      }
    });
    return Promise.resolve({ eau, irrigation });
  },


/* 
███████╗░█████╗░██╗░░░██╗  ████████╗██████╗░░█████╗░░█████╗░░█████╗░
██╔════╝██╔══██╗██║░░░██║  ╚══██╔══╝██╔══██╗██╔══██╗██╔══██╗██╔══██╗
█████╗░░███████║██║░░░██║  ░░░██║░░░██████╔╝███████║██║░░╚═╝██║░░╚═╝
██╔══╝░░██╔══██║██║░░░██║  ░░░██║░░░██╔══██╗██╔══██║██║░░██╗██║░░██╗
███████╗██║░░██║╚██████╔╝  ░░░██║░░░██║░░██║██║░░██║╚█████╔╝╚█████╔╝
╚══════╝╚═╝░░╚═╝░╚═════╝░  ░░░╚═╝░░░╚═╝░░╚═╝╚═╝░░╚═╝░╚════╝░░╚════╝░ */

getEauIrrigationTRACC({ idProdu, semis, gridno }) {
    const semisDate = semisToDate(semis);
    const seedEau = seedFrom(String(idProdu || "") + String(gridno || ""));
    const seedIrr = seedFrom(String(idProdu || "") + String(gridno || "") + "irr");
    const eau = [];
    const irrigation = [];
    RECHAUFFEMENT.forEach((Years, yi) => {
      for (let j = 1; j <= 180; j += 2) {
        const dateAffichage = addDays(semisDate, j);

        const climatFactorEau = 1 + yi * 0.18;
        const baseEau = 2.5 + 2 * Math.sin((j / 180) * Math.PI);
        const bruitEau = (rand(seedEau + j * 7 + yi * 1000) - 0.5) * 0.6;
        eau.push({
          Years,
          jour_campagne: j,
          date_affichage: dateAffichage,
          besoin_moy: Number(Math.max(0, baseEau * climatFactorEau + bruitEau).toFixed(2)),
          besoin_sd: Number((0.4 + rand(seedEau + j) * 0.4).toFixed(2)),
        });

        const climatFactorIrr = 1 + yi * 0.22;
        const baseIrr = 1.2 + 1.5 * Math.sin((j / 180) * Math.PI);
        const bruitIrr = (rand(seedIrr + j * 5 + yi * 900) - 0.5) * 0.4;
        irrigation.push({
          Years,
          jour_campagne: j,
          date_affichage: dateAffichage,
          irr_moy: Number(Math.max(0, baseIrr * climatFactorIrr + bruitIrr).toFixed(2)),
          irr_sd: Number((0.2 + rand(seedIrr + j) * 0.2).toFixed(2)),
        });
      }
    });
    return Promise.resolve({ eau, irrigation });
  },

 

/* 
███╗░░░███╗░█████╗░██████╗░░██████╗░███████╗
████╗░████║██╔══██╗██╔══██╗██╔════╝░██╔════╝
██╔████╔██║███████║██████╔╝██║░░██╗░█████╗░░
██║╚██╔╝██║██╔══██║██╔══██╗██║░░╚██╗██╔══╝░░
██║░╚═╝░██║██║░░██║██║░░██║╚██████╔╝███████╗
╚═╝░░░░░╚═╝╚═╝░░╚═╝╚═╝░░╚═╝░╚═════╝░╚══════╝ */

  getMarge({ idProdu, gridno, par_ha }) {
    const seed = seedFrom(String(idProdu || "") + String(gridno || "") + "marge");
    const modalites = [
      "sec", "irrigue_100", "stricte_1_5ans", "stricte_2_10ans",
      "stricte_3_15ans", "stricte_4_20ans", "stricte_5_25ans",
    ];
    const unite = par_ha ? 1 : 45; // simule "surface * marge/ha"
    const rows = [];
    modalites.forEach((modalite, mi) => {
      let cumul = 0;
      for (let year = 2020; year <= 2050; year++) {
        const base = (mi - 1) * 150 - (year - 2020) * 8;
        const bruit = (rand(seed + year + mi * 50) - 0.5) * 200;
        const marge_annuelle = Math.round((base + bruit) * unite) / (par_ha ? 1 : 1);
        cumul += marge_annuelle;
        rows.push({
          modalite,
          year,
          marge_annuelle,
          marge_cumulee: Math.round(cumul),
          borne_bas: Math.round(marge_annuelle * 0.8),
          borne_haut: Math.round(marge_annuelle * 1.2),
          cumul_bas: Math.round(cumul * 0.85),
          cumul_haut: Math.round(cumul * 1.15),
        });
      }
    });
    return Promise.resolve(rows);
  },

/* 
██████╗░███████╗███╗░░██╗████████╗░█████╗░██████╗░██╗██╗░░░░░██╗████████╗███████╗
██╔══██╗██╔════╝████╗░██║╚══██╔══╝██╔══██╗██╔══██╗██║██║░░░░░██║╚══██╔══╝██╔════╝
██████╔╝█████╗░░██╔██╗██║░░░██║░░░███████║██████╦╝██║██║░░░░░██║░░░██║░░░█████╗░░
██╔══██╗██╔══╝░░██║╚████║░░░██║░░░██╔══██║██╔══██╗██║██║░░░░░██║░░░██║░░░██╔══╝░░
██║░░██║███████╗██║░╚███║░░░██║░░░██║░░██║██████╦╝██║███████╗██║░░░██║░░░███████╗
╚═╝░░╚═╝╚══════╝╚═╝░░╚══╝░░░╚═╝░░░╚═╝░░╚═╝╚═════╝░╚═╝╚══════╝╚═╝░░░╚═╝░░░╚══════╝ */

  getSubvention({ capex } = {}) {
    const equipements = [
      { equipement: "Pivot", capex:  70000 },
      { equipement: "Goutte-à-goutte", capex:  95000 },
      { equipement: "Canon enrouleur", capex:  45000 },
      { equipement: "Rampe frontale", capex:  110000 },
    ];
    return Promise.resolve(
      equipements.map((e, i) => {
        const vp_marges = Math.round(e.capex * (0.5 + i * 0.08));
        return {
          ...e,
          vp_marges,
          subvention: Math.max(0, e.capex - vp_marges),
        };
      })
    );
  },


/*   
████████╗███████╗██████╗░██████╗░██╗████████╗░█████╗░██╗██████╗░███████╗
╚══██╔══╝██╔════╝██╔══██╗██╔══██╗██║╚══██╔══╝██╔══██╗██║██╔══██╗██╔════╝
░░░██║░░░█████╗░░██████╔╝██████╔╝██║░░░██║░░░██║░░██║██║██████╔╝█████╗░░
░░░██║░░░██╔══╝░░██╔══██╗██╔══██╗██║░░░██║░░░██║░░██║██║██╔══██╗██╔══╝░░
░░░██║░░░███████╗██║░░██║██║░░██║██║░░░██║░░░╚█████╔╝██║██║░░██║███████╗
░░░╚═╝░░░╚══════╝╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░░╚═╝░░░░╚════╝░╚═╝╚═╝░░╚═╝╚══════╝ */

  getTerritoire({ idProdu, gridno, pct_irrig }) {
    const seed = seedFrom(String(idProdu || "") + String(gridno || "") + "territoire");
    const pct = (pct_irrig ?? 50) / 100;
    let cumul = 0;
    const rows = [];
    for (let year = 2025; year <= 2055; year++) {
      const tours_moy = Number((3 + rand(seed + year) * 3).toFixed(1));
      const surf_irrig = Math.round((80 + rand(seed + year * 2) * 40) * pct);
      const vol_annuel = Math.round(tours_moy * 250 * surf_irrig);
      cumul += vol_annuel;
      rows.push({ year, tours_moy, surf_irrig, vol_annuel, vol_cumule: cumul });
    }
    return Promise.resolve(rows);
  },


/* 
██████╗░██████╗░████████╗██╗░░██╗
██╔══██╗██╔══██╗╚══██╔══╝╚██╗██╔╝
██████╔╝██████╔╝░░░██║░░░░╚███╔╝░
██╔═══╝░██╔═══╝░░░░██║░░░░██╔██╗░
██║░░░░░██║░░░░░░░░██║░░░██╔╝╚██╗
╚═╝░░░░░╚═╝░░░░░░░░╚═╝░░░╚═╝░░╚═╝ */

  exportPptx() {
    return Promise.reject(
      new Error("Export PPTX indisponible en mode démo (mock) — à tester une fois l'API branchée.")
    );
  },
};
